"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _server = require("react-dom/server");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fuseUtils = require("@tvg/fuse-utils");
var _configIcon = require("./configIcon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var getVolumeByViewport = function getVolumeByViewport(iconSize) {
  var _configIcon$iconSize, _configIcon$iconSize2;
  return "\n\twidth: ".concat((_configIcon$iconSize = _configIcon.configIcon[iconSize]) === null || _configIcon$iconSize === void 0 ? void 0 : _configIcon$iconSize.width, ";\n\theight: ").concat((_configIcon$iconSize2 = _configIcon.configIcon[iconSize]) === null || _configIcon$iconSize2 === void 0 ? void 0 : _configIcon$iconSize2.height, ";\n");
};
var setVolume = function setVolume(responsiveSize) {
  var _buildResponsiveSize = (0, _fuseUtils.buildResponsiveSize)(responsiveSize),
    _buildResponsiveSize2 = _slicedToArray(_buildResponsiveSize, 2),
    isResponsive = _buildResponsiveSize2[0],
    setViewportCss = _buildResponsiveSize2[1];
  return isResponsive ? setViewportCss(getVolumeByViewport) : getVolumeByViewport(responsiveSize);
};
var setSize = function setSize(height, width, responsiveSize) {
  if (height || width) {
    var iconHeight = height || _configIcon.configIcon.xsmall.height;
    var iconWidth = width || iconHeight;
    return "\n\t\t\theight: ".concat(iconHeight, ";\n\t\t\twidth: ").concat(iconWidth, ";\n\t\t");
  }
  return setVolume(responsiveSize);
};
var StyledIcon = _styledComponents["default"].span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['responsiveSize', 'icon'].includes(prop);
  }
}).attrs({
  className: "fuse-icon"
}).withConfig({
  displayName: "styled-icon-element__StyledIcon",
  componentId: "sc-5m8j1g-0"
})(["", ""], function (_ref) {
  var icon = _ref.icon,
    color = _ref.color,
    height = _ref.height,
    width = _ref.width,
    responsiveSize = _ref.responsiveSize;
  var iconColor = color;
  return "\n\t\t\tbackground: ".concat(iconColor, ";\n\t\t\tdisplay: inline-flex;\n\t\t\tmask: url('data:image/svg+xml,").concat(encodeURIComponent((0, _server.renderToStaticMarkup)(icon)), "') center/contain no-repeat;\n\t\t\t-webkit-mask: url('data:image/svg+xml,").concat(encodeURIComponent((0, _server.renderToStaticMarkup)(icon)), "') center/contain no-repeat;\n\t\t\tposition: relative;\n\n\t\t\t").concat(setSize(height, width, responsiveSize), ";\n\n\t\t\t&[disabled] {\n\t\t\t\tbackground-color: var(--color-global-grey400);\n\t\t\t}\n\t\t");
});
var _default = exports["default"] = StyledIcon;